document.addEventListener('DOMContentLoaded', function () {
  function getSelectedStoreTitle() {
    const activeStore = document.querySelector('.store-selector-item--store--active');
    if (!activeStore) return null;

    const titleEl = activeStore.querySelector('.store-selector-item__title');
    return titleEl ? titleEl.textContent.trim().toLowerCase() : null;
  }

  function filterProductsByAvailability() {
    const selectedStore = getSelectedStoreTitle();
    if (!selectedStore) return;

    document.querySelectorAll('.product-card').forEach(function (card) {
      const availabilityEl = card.querySelector('.local-availability');
      if (!availabilityEl) return;

      const text = availabilityEl.textContent.trim().toLowerCase();
      const isOutOfStock = text.includes('out of stock') && text.includes(selectedStore);
      card.style.display = isOutOfStock ? 'none' : '';
    });
  }

  filterProductsByAvailability();

  document.querySelectorAll('.store-selector-item input[type="checkbox"]').forEach(function (checkbox) {
    checkbox.addEventListener('change', function () {
      setTimeout(filterProductsByAvailability, 50);
    });
  });
});
